import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import CreateSchedule from '@/components/ezuro/workschedule/components/CreateSchedule.vue';

export default {
  name: 'ScheduleNotesEdit',
  components: {
    CreateSchedule
  },
  props: {
    isModal: {
      type: Boolean,
      default: true
    },
    filterData: {
      type: Object
    },
    scheduleData: {
      type: Object
    }
  },
  data () {
    return {
      id: null,
      scheduleId: null,
      departmentId: null,
      divisionId: null,
      day: null,
      notes: null,
      isTableView: false,
      isLoading: false
    }
  },
  validations: {
    scheduleId: { required },
    departmentId: { required },
    divisionId: { },
    day: { required },
    notes: { }
  },
  computed: {
    departmentOptions () {
      if (!this.filterData.company_id) {
        return [];
      }
      const departments = this.$store.getters.getConfigOptions(
        'company_departments',
        this.$i18n.locale,
        null, null, false, false, false,
        ['company_id']
      ).filter(
        el => {
          return (
            this.filterData.company_id.includes(parseInt(el.company_id)) &&
            (!this.filterData.department_id.length || this.filterData.department_id.includes(parseInt(el.value)))
          );
        }
      );

      return this.BasicHelper.sortArrayByKeyValue(departments, 'sortText');
    },
    divisionOptions () {
      const divisions = this.$store.getters.getConfigOptions(
        'company_divisions',
        this.$i18n.locale,
        null, null, false, false, false,
        ['department_id']
      ).filter(
        el => {
          return this.departmentId == parseInt(el.department_id);
        }
      );

      return this.BasicHelper.sortArrayByKeyValue(divisions, 'sortText');
    },
    getTitle () {
      return this.$t('work-schedule.edit-schedule-notes');
    },
    canEdit () {
      return !this.isLoading;
    },
    hasShedule () {
      return this.scheduleId;
    },
    isScheduleLocked () {
      if (this.scheduleId) {
        for (const key in this.scheduleData.schedules) {
          if (
            this.scheduleData.schedules[key].id == this.scheduleId &&
            this.scheduleData.schedules[key].status == 'confirmed'
          ) {
            return true;
          }
        }
      }
      return false;
    }
  },
  methods: {
    getDepartmentName (id) {
      return id ? this.$store.getters.getParamFromConfig('company_departments', id, 'name', this.$i18n.locale) : null;
    },
    getDivisionName (id) {
      return id ? this.$store.getters.getParamFromConfig('company_divisions', id, 'name', this.$i18n.locale) : null;
    },
    departmentSelect (id) {
      this.departmentId = id;
      this.divisionoId = null;
      this.getNotes();
    },
    divisionSelect (id) {
      this.divisionoId = id;
      this.getNotes();
    },
    createdSchedule (data) {
      this.scheduleId = data.id;
      this.$emit('createdSchedule');
    },
    getScheduleId () {
      this.scheduleId = null;
      for (const key in this.scheduleData.schedules) {
        if (
          this.scheduleData.schedules[key].department_id == this.departmentId &&
          this.scheduleData.schedules[key].division_id == this.divisionId &&
          this.scheduleData.schedules[key].type === this.filterData.type
        ) {
          this.scheduleId = this.scheduleData.schedules[key].id;
          return;
        }
      }
    },
    getNotes () {
      this.notes = null;
      this.id = null;
      this.getScheduleId();
      for (const key in this.scheduleData.notes) {
        if (
          this.scheduleData.notes[key].schedule_id == this.scheduleId &&
          this.scheduleData.notes[key].day == this.day
        ) {
          this.id = this.scheduleData.notes[key].id
          this.notes = this.scheduleData.notes[key].notes;
          return;
        }
      }
    },
    show (sqlDay, data = null) {
      this.id = null;
      this.scheduleId = data ? data.scheduleId : null;
      this.departmentId = data ? data.departmentId : null;
      this.divisionId = data ? data.divisionId : null;
      this.isTableView = data ? data.isTableView : false;
      this.notes = null;
      this.day = sqlDay;

      if (!data && this.filterData.department_id.length === 1) {
        this.departmentId = this.filterData.department_id[0];
      }

      if (!data && this.filterData.division_id.length === 1) {
        this.divisionId = this.filterData.division_id[0];
      }

      this.getNotes();
      this.v$.$reset();

      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    save () {
      this.v$.$touch();
      if (!this.v$.$invalid && !this.isLoading) {
        this.isLoading = true;
        const reqData = {
          schedule_id: this.scheduleId,
          day: this.day,
          notes: this.notes
        };
        this.ApiRequest.request('ezuro/schedule/note/save' + (this.id ? '/' + this.id : ''), this.ApiRequest.REQUEST_POST, reqData, (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
          } else {
            this.$emit('filter');
            this.close();
          }
          this.isLoading = false;
        });
      }
    },
    remove () {
      this.isLoading = true;
      this.ApiRequest.request('ezuro/schedule/note/destroy/' + this.id, this.ApiRequest.REQUEST_GET, { }, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          this.$emit('filter');
          this.close();
        }
        this.isLoading = false;
      });
    },
    close () {
      if (this.isModal) {
        this.$refs['modal-window'].hide();
      }
    }
  },
  setup () {
    return { v$: useVuelidate() }
  }
}
